import React, { useContext } from 'react';
import { Dialog, Slide } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import videoPopupContent from './videoPopup';
// import videoPopup from './videoPopup';

export const VideoPopupModal = ({ onHide, isVisible, showVideo }) => {
  const useStyles = makeStyles({
    dots: true,
  });
  const classes = useStyles();
  return (
    <Dialog
      classes={{ root: classes.content }}
      onClose={onHide}
      open={isVisible}
      PaperProps={{ onHide, isVisible, showVideo }}
      TransitionComponent={Slide}
      PaperComponent={videoPopupContent}
    />
  );
};
